module.exports = __webpack_public_path__ + "img/img8.aff2f881.png";